import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62f2e801&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=62f2e801&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f2e801",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f2e801')) {
      api.createRecord('62f2e801', component.options)
    } else {
      api.reload('62f2e801', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=62f2e801&scoped=true", function () {
      api.rerender('62f2e801', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/storeInfo/index.vue"
export default component.exports